/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: program_user.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  AddProgramUserRoleRequest,
  AddProgramUserRoleResponse,
  ChangeProgramUserRoleRequest,
  ChangeProgramUserRoleResponse,
  GetProgramUserRolesRequest,
  GetProgramUserRolesResponse,
  RemoveProgramUserRoleRequest,
  RemoveProgramUserRoleResponse,
  SearchProgramUsersRequest,
  SearchProgramUsersResponse,
} from '../types/program_user';

export const createProgramUserService = (transport: Transport) => ({
  async searchProgramUsers(
    request: SearchProgramUsersRequest,
    options: RequestOptions = {},
  ): Promise<SearchProgramUsersResponse> {
    const { organization_id, program_id, ...params } = request;
    const url = getApiPath(API_METHODS.ProgramUserService.SearchProgramUsers, {
      organization_id,
      program_id,
    });
    return transport.get<SearchProgramUsersResponse>(url, { params, ...options });
  },

  async getProgramUserRoles(
    request: GetProgramUserRolesRequest,
    options: RequestOptions = {},
  ): Promise<GetProgramUserRolesResponse> {
    const { organization_id, program_id, user_id, ...params } = request;
    const url = getApiPath(API_METHODS.ProgramUserRoleService.GetProgramUserRoles, {
      organization_id,
      program_id,
      user_id,
    });
    return transport.get<GetProgramUserRolesResponse>(url, { params, ...options });
  },

  async addProgramUserRole(
    request: AddProgramUserRoleRequest,
    options: RequestOptions = {},
  ): Promise<AddProgramUserRoleResponse> {
    const { organization_id, program_id, user_id, ...body } = request;
    const url = getApiPath(API_METHODS.ProgramUserRoleService.AddProgramUserRole, {
      organization_id,
      program_id,
      user_id,
    });
    return transport.post<AddProgramUserRoleResponse>(url, body, options);
  },

  async removeProgramUserRole(
    request: RemoveProgramUserRoleRequest,
    options: RequestOptions = {},
  ): Promise<RemoveProgramUserRoleResponse> {
    const { organization_id, program_id, user_id, ...body } = request;
    const url = getApiPath(API_METHODS.ProgramUserRoleService.RemoveProgramUserRole, {
      organization_id,
      program_id,
      user_id,
    });
    return transport.delete<RemoveProgramUserRoleResponse>(url, { data: body, ...options });
  },

  async changeProgramUserRole(
    request: ChangeProgramUserRoleRequest,
    options: RequestOptions = {},
  ): Promise<ChangeProgramUserRoleResponse> {
    const { organization_id, program_id, user_id, ...body } = request;
    const url = getApiPath(API_METHODS.ProgramUserRoleService.ChangeProgramUserRole, {
      organization_id,
      program_id,
      user_id,
    });
    return transport.post<ChangeProgramUserRoleResponse>(url, body, options);
  },
});

export type ProgramUserService = ReturnType<typeof createProgramUserService>;
